<script setup lang="ts">
import MenuNavigation from '@/Components/Menu/MenuNavigation.vue'
import { Link, router, usePage } from '@inertiajs/vue3'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import MenuNavigationItem from '../MenuNavigationItem.vue'
import BraceletsPanel from './BraceletsPanel.vue'
import CatalogPanel from './CatalogPanel.vue'
import EarringsPanel from './EarringsPanel.vue'
import PendantsPanel from './PendantsPanel.vue'
import RingsPanel from './RingsPanel.vue'

const props = defineProps<{
    closeMenu: Function,
}>()

const onNavigate = () => {
    props.closeMenu()
}

onUnmounted(router.on('start', onNavigate))

const page = usePage()
const sections = computed(() => page.props.layout.menu.navbar)
const selected = ref<string>(sections.value[0].code)

const selectedSection = computed(() => sections.value.find((section) => section.code === selected.value))

const menuComponent = (code: string) => {
    switch (code) {
        case 'all':
            return CatalogPanel
        case 'earrings':
            return EarringsPanel
        case 'rings':
            return RingsPanel
        case 'bracelets':
            return BraceletsPanel
        case 'pendants':
            return PendantsPanel
    }

    return null
}
</script>

<template>
    <div class="flex gap-x-8">
        <MenuNavigation class="flex-shrink-0 w-52">
            <MenuNavigationItem
                v-for="(section, sectionIdx) in sections"
                :key="sectionIdx"
                :title="$t(`components.menu.catalog.sections.${section.code}.title`)"
                :code="section.code"
                link="#test"
                :active="section.code === selected"
                @click="selected = section.code"
            />
        </MenuNavigation>

        <!-- <template
            v-for="(section, sectionIdx) in sections"
            :key="sectionIdx"
        > -->
        <component
            :is="menuComponent(selectedSection.code)"
            v-show="selected === selectedSection.code"
            v-if="selectedSection && menuComponent(selectedSection?.code)"
            :menu="selectedSection"
            class="flex-1"
        />
        <!-- </template> -->
    </div>
</template>
